import script from "./menuPop.vue?vue&type=script&setup=true&lang=js"
export * from "./menuPop.vue?vue&type=script&setup=true&lang=js"

import "./menuPop.vue?vue&type=style&index=0&id=3ea796bc&lang=scss&scoped=true"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea796bc"]])

export default __exports__